// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --themeColor: #fafaff;
  --themeFontColor: #000000;
  --themeColorLighterShade: #e6e6ef;
  --themeColorLightestShade: #f0f0f4;
  --themeShadowColor: rgba(50, 50, 93, 0.25);
  --themeShadowLighterColor: rgba(0, 0, 0, 0.3);
  --themeShadow: var(--themeShadowColor) 0px 6px 12px -2px,
    var(--themeShadowLighterColor) 0px 3px 7px -3px;
  --tableHeadFontColor: #fff;
  --formBorderLineColor: rgba(255, 255, 255, 0.1);
}

/* ::-webkit-scrollbar {
  width: 0px !important;
}

::-webkit-scrollbar-track {
  background: #f1f1f100 !important; 
}

::-webkit-scrollbar-thumb {
  background: #88888800 !important; 
}

::-webkit-scrollbar-thumb:hover {
  background: #55555500 !important; 
} */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* * {
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important;

} */
* {
  font-family: "JesayaBk-Regular" !important;
  letter-spacing: 0.5px !important;
}
input[value=""]::-webkit-datetime-edit {
  /* color: transparent; 
  -webkit-text-fill-color: #5b5b9800; */
}

/* input,.Mui-disabled{
  color:black !important;
  -webkit-text-fill-color: #000 !important;
} */
input {
  color: var(--themeFontColor) !important;
  -webkit-text-fill-color: var(--themeFontColor) !important;
  color-scheme: var(--themeFontColor) !important;
}
.Mui-disabled {
  /* color:var(--themeFontColor) !important; */
  /* -webkit-text-fill-color: var(--themeFontColor) !important; */
}
td img {
  max-height: 4rem;
  max-width: 4rem;
  border-radius: 10px;
  /* box-shadow: var(--themeShadow); */
}
a {
  text-decoration: none !important;
}
/* a:focus{
  color: var(--themeFontColor) !important;
  
} */
/* thead th:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
thead th:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
} */
/* .MuiOutlinedInput-notchedOutline{
  outline: #000 !important;
  border-color: #000 !important;
} */
.MuiOutlinedInput-notchedOutline {
  outline: var(--themeFontColor) !important;
  border-color: var(--themeFontColor) !important;
}
.MuiChip-label,
.MuiCheckbox-root,
.MuiSelect-select,
.css-16901u4-MuiFormLabel-root,
.css-17xv29d-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root,
.MuiOutlinedInput-notchedOutline {
  border-radius: 10px !important;
  /* border-color: black !important; */
  /* color:black !important; */
  color: var(--themeFontColor) !important;
}
.MuiInputLabel-root,
.MuiInputLabel-formControl {
  color: var(--themeFontColor) !important;
}
.css-12rm877-MuiPaper-root-MuiAutocomplete-paper {
  color: red !important;
}

.rs-picker-default .rs-picker-toggle.rs-btn-lg {
  height: auto !important;
  width: 100% !important;
  padding: 16.5px 14px !important;
  padding-left: 48px !important;
  font-size: 0.8571428571428571rem !important;
  background: rgb(0, 0, 0, 0) !important;
  border: black 1px solid !important;
  border-radius: 8px !important;
}
.rs-btn-md {
  height: auto !important;
  width: 100% !important;
  padding: 10px 14px !important;
  /* padding-left: 48px !important; */
  font-size: 0.8571428571428571rem !important;
  background: var(--themeColor) !important;
  border: var(--themeColor) 1px solid !important;
  border-radius: 8px !important;
}
/* .rs-picker-default .rs-btn .rs-picker-default .rs-picker-toggle {
  background-color: black !important;

} */
.rs-picker-default .rs-btn,
.rs-picker-input .rs-btn,
.rs-picker-default .rs-picker-toggle,
.rs-picker-input .rs-picker-toggle {
  background-color: var(--themeColor) !important;
}
.rs-picker-toggle-caret {
  top: 30% !important;
}
.rs-picker-toggle-value,
.rs-picker-toggle-textbox {
  color: var(--themeFontColor) !important;
    background-color: var(--themeColor) !important;
}
.MuiFormLabel-asterisk,
.MuiInputLabel-asterisk,
.MuiFormHelperText-root {
  color: red !important;
}

.Mui-selected {
  background-color: var(--themeColor) !important;
}
/* tr td:first-child {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
tr td:last-child {
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
} */
.MuiAutocomplete-option {
  background-color: var(--themeColor) !important;
}
.MuiAutocomplete-option:hover {
  background-color: var(--themeColor) !important;
}
.MuiAlert-root {
  background-color: transparent !important;
  background: linear-gradient(
    225deg,
    var(--gradientColor1) 0%,
    var(--gradientColor2) 91.25%
  ) !important;
  color: var(--tableHeadFontColor) !important;
}
.invalid-number-message {
  background: var(--themeFontColor) !important;
}
/* .css-4o1hlg-MuiGrid-root{
display: inline !important;
} */

.css-4o1hlg-MuiGrid-root {
  flex-wrap: nowrap !important;
}
/* dark  mode */
.css-eyrg6t-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator {
  color: var(--themeFontColor) !important;
}
.apexcharts-legend-text {
  color: #e55e08 !important;
}
.css-1rqvyhg-MuiButtonBase-root-MuiMenuItem-root {
  color: #e55e08 !important;
}
/* top bar */
.css-1m7rcoi-MuiPaper-root-MuiAppBar-root {
  background-color: var(--themeColor) !important;
}
.css-vcjevh-MuiButtonBase-root-MuiIconButton-root {
  color: var(--themeFontColor) !important;
}
.CurrentDate_currentDate__wTUkF {
  border: 1px solid var(--themeFontColor) !important;
  color: var(--themeFontColor) !important;
}
.Notifications_Notifications__s5SGE {
  border: 1px solid var(--themeFontColor) !important;
  color: green !important;
}
/* chart */
.apexcharts-toolbar {
  background-color: var(--themeFontColor);
}
.css-gaunrm-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
  /* border: 1px solid #363535 ; */
  box-shadow: var(--themeShadow) !important;
}
.css-uhtw1w-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
  box-shadow: var(--themeShadow) !important;

  /* border: 1px solid #363535 ; */
}
.css-1ie4o9w-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
  box-shadow: var(--themeShadow) !important;

  /* border: 1px solid #363535 ; */
}
.css-1eg9ojj-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
  /* border: 1px solid #363535 ; */
  box-shadow: var(--themeShadow) !important;
}
/* table */
.css-upajmk-MuiTablePagination-selectLabel {
  color: var(--themeFontColor);
}
.css-11ceysh-MuiTablePagination-displayedRows {
  color: var(--themeFontColor);
}
.css-1knvo2r-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}
.css-mja77w-MuiTableRow-root.MuiTableRow-hover:hover {
  background-color: var(--themeColor) !important;
}
.css-1hrspu2-MuiPaper-root-MuiTableContainer-root {
  background-color: var(--themeColor) !important;
}
.css-geaot0-MuiButtonBase-root-MuiMenuItem-root-MuiTablePagination-menuItem {
  color: red !important;
}
/* video details */
.css-zqdn1f-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}
.css-1bzmum7-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
  border: 1px solid #363535;
}
.css-kke3go-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}
/* form */
.css-g5736s-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}
.css-7imk2x-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}
.css-1bqcgw2-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {
  background-color: var(--themeColor) !important;
}
.css-q8j02b {
  background-color: var(--themeColor) !important;
}
.css-drd2zr-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {
  color: var(--themeFontColor) !important;
}
.css-1a2gpc6-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}
.form_phoneInput__pFBPS {
  border: 1px solid red !important;
}
.form_phoneInput__LEbig {
  border: 1px solid var(--themeFontColor) !important;
}
/* customer details */
.css-ytlvh1-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
  /* border: 1px solid #363535 ; */
  box-shadow: var(--themeShadow) !important;
}
.css-130ds3b-MuiPaper-root-MuiCard-root {
  background: linear-gradient(
    225deg,
    var(--themeColor) 0%,
    #232121 91.25%
  ) !important;
  /* border: 1px solid #363535 ; */
  box-shadow: var(--themeShadow) !important;
}
.css-1nzdg76-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
  /* border: 1px solid #363535 ; */
  box-shadow: var(--themeShadow) !important;
}
.css-8oekft-MuiTableHead-root {
  background-color: var(--themeColor) !important;
  /* border: 1px solid #363535 ; */
  box-shadow: var(--themeShadow) !important;
}
.css-emol3q-MuiTableCell-root {
  border-bottom: 1px solid rgb(97 97 97) !important;
}
.css-1vckdgf-MuiTableCell-root {
  border-bottom: 1px solid rgb(97 97 97) !important;
}
.css-14a324z-MuiTableCell-root {
  border-bottom: 1px solid rgb(97 97 97) !important;
}
.css-ryg23w-MuiTableCell-root {
  border-bottom: 1px solid rgb(97 97 97) !important;
}
.css-fdk6dw {
  border-bottom: 1px solid rgb(97 97 97) !important;
}
/* description */
.mantine-1qycoz3 .ql-editor {
  background-color: var(--themeColor) !important;
  color: var(--themeFontColor);
}
.mantine-bdajhj {
  background-color: var(--themeColor) !important;
}
/* login page */
.css-1rlv2y8 {
  background-color: var(--themeColor) !important;
}
.css-1rlv2y8 {
  background-color: var(--themeColor) !important;
}
/* series Details */
.css-j5uqg9-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}
/* movie details */
.css-q327nh-MuiTableCell-root {
  border-bottom: 1px solid rgb(97 97 97) !important;
}
.css-1kxu69z {
  color: var(--themeFontColor) !important;
}
.css-1trvfeo-MuiPaper-root-MuiCard-root {
  background-color: #363535 !important;
  box-shadow: var(--themeShadow) !important;

  border: 1px solid #363535;
}

/* popup */
.css-13oa6c8 {
  background: var(--themeColor) !important;
}
.css-228tnr-MuiPaper-root-MuiCard-root {
  background-color: var(--themeColor) !important;
}

/* log in form */
.css-poa6bm-MuiButtonBase-root-MuiIconButton-root {
  color: var(--themeFontColor) !important;
}

.rs-picker-menu {
  background-color: var(--themeColorLighterShade) !important;
  color: var(--themeFontColor) !important;
}

.rs-picker-toggle-textbox {
  background-color: var(--themeColorLighterShade) !important;
  /* border: 1px solid var(--themeFontColor) !important; */
}

.rs-picker-toggle-textbox:visited {
  background-color: var(--themeColorLighterShade) !important;
  /* border: 1px solid var(--themeFontColor) !important; */
}

.rs-picker-toggle-wrapper {
  /* border: 1px solid var(--themeFontColor); */
  border-radius: 0.5rem;
}

.rs-picker:not(.rs-picker-disabled):hover,
.rs-picker.rs-picker-focused {
  /* border: 1px solid var(--themeFontColor) !important; */
  background-color: var(--themeColorLighterShade) !important;
}

.rs-calendar-table-cell:hover {
  background-color: var(--themeColorLighterShade);
  color: var(--themeColor);
}
.rs-calendar-table-cell-selected .rs-calendar-table-cell-selected-start {
  background-color: var(--themeColorLighterShade) !important;
}

.rs-picker-menu
  .rs-calendar
  .rs-calendar-table-cell:hover
  .rs-calendar-table-cell-content {
  background-color: var(--themeColorLighterShade) !important;
  color: var(--themeFontColor);
}
.calendar-bg .rs-picker-toggle-wrapper {
  width: 100% !important;
}

.calendar-bg .rs-picker-date .rs-picker-toggle.rs-btn-md,
.rs-picker-daterange .rs-picker-toggle.rs-btn-md {
  background-color: var(--themeColorLighterShade) !important;
   color: var(--themeFontColor) !important;
}
.custom-date-picker {
  border-radius: 2px !important;
  background-color: var(--themeColorLighterShade) !important;
}

.custom-date-picker input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 100px var(--themeColorLighterShade) inset !important;
  -webkit-text-fill-color: var(--themeFontColor) !important;
}

.dark-mode .custom-date-picker input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 100px rgb(22, 22, 22) inset !important;
}

.light-mode .custom-date-picker input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 100px rgb(255, 255, 255) inset !important;
}

.features_box:hover {
  /* box-shadow: 0em 0.5em .5em -0.4em rgba(226, 93, 102, 0.8),
  
  0.5em 0em .5em -0.4em rgba(226, 93, 102, 0.8),
  0em -0.5em .5em -0.4em rgba(157, 88, 163, 0.8),
  
  -0.5em 0em .5em -0.4em rgba(157, 88, 163, 0.8)

 ; */
  /* background:linear-gradient(270deg,rgba(157, 88, 163, 0.8),rgba(226, 93, 102, 0.8)) ; */
  background: linear-gradient(
    270deg,
    var(--gradientColor1),
    var(--gradientColor2)
  );

  box-shadow: none !important;
}
.features_box:hover span {
  color: white !important;
}
.jvectormap-container {
  width: 100%;
  height: 100%;
}
.jvectormap-tip {
  position: absolute !important;
}
.jvectormap-tip:empty {
  display: none;
}
.map {
  height: 50vh;
}
#root .css-1klsplc-MuiStepLabel-label.Mui-error {
  color: #d32f2f !important;
}
#root .css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-error {
  color: #d32f2f !important;
}
.css-8t4c91 {
  width: 100% !important;
}

.css-1kxloj4-MuiButtonBase-root-MuiButton-root-MuiLoadingButton-root.Mui-disabled {
  color: #fff !important;
}
.css-1hfcet8-MuiTableRow-root {
  background-color: var(--themeColor) !important;
}
/* Base styling */
.scrollable-content::-webkit-scrollbar {
  width: 8px;
}
.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

/* Dark mode scrollbar */
.dark-scrollbar::-webkit-scrollbar-thumb {
  background-color: #555; /* dark thumb */
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.dark-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #777;
}

/* Light mode scrollbar */
.light-scrollbar::-webkit-scrollbar-thumb {
  background-color: #bbb; /* light thumb */
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.light-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}

/* Optional: Firefox support */
.scrollable-content {
  scrollbar-width: thin;
}
.dark-scrollbar {
  scrollbar-color: #555 transparent;
}
.light-scrollbar {
  scrollbar-color: #bbb transparent;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;EACjC,kCAAkC;EAClC,0CAA0C;EAC1C,6CAA6C;EAC7C;mDACiD;EACjD,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;;;;;;;;;;;;;;GAcG;AACH;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;GAGG;AACH;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;EACE;uCACqC;AACvC;;AAEA;;;GAGG;AACH;EACE,uCAAuC;EACvC,yDAAyD;EACzD,8CAA8C;AAChD;AACA;EACE,4CAA4C;EAC5C,+DAA+D;AACjE;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;;;GAGG;AACH;;;;;;;GAOG;AACH;;;GAGG;AACH;EACE,yCAAyC;EACzC,8CAA8C;AAChD;AACA;;;;;;EAME,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,uCAAuC;AACzC;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,2CAA2C;EAC3C,sCAAsC;EACtC,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,mCAAmC;EACnC,2CAA2C;EAC3C,wCAAwC;EACxC,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA;;;GAGG;AACH;;;;EAIE,8CAA8C;AAChD;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,uCAAuC;IACrC,8CAA8C;AAClD;AACA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;AACA;;;;;;;GAOG;AACH;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,wCAAwC;EACxC;;;;cAIY;EACZ,2CAA2C;AAC7C;AACA;EACE,4CAA4C;AAC9C;AACA;;GAEG;;AAEH;EACE,4BAA4B;AAC9B;AACA,eAAe;AACf;EACE,uCAAuC;AACzC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,YAAY;AACZ;EACE,8CAA8C;AAChD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE,kDAAkD;EAClD,uBAAuB;AACzB;AACA,UAAU;AACV;EACE,uCAAuC;AACzC;AACA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yCAAyC;AAC3C;AACA;EACE,8CAA8C;EAC9C,yCAAyC;;EAEzC,gCAAgC;AAClC;AACA;EACE,8CAA8C;EAC9C,yCAAyC;;EAEzC,gCAAgC;AAClC;AACA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yCAAyC;AAC3C;AACA,UAAU;AACV;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,qBAAqB;AACvB;AACA,kBAAkB;AAClB;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,8CAA8C;AAChD;AACA,SAAS;AACT;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kDAAkD;AACpD;AACA,qBAAqB;AACrB;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yCAAyC;AAC3C;AACA;EACE;;;;cAIY;EACZ,gCAAgC;EAChC,yCAAyC;AAC3C;AACA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yCAAyC;AAC3C;AACA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yCAAyC;AAC3C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA,gBAAgB;AAChB;EACE,8CAA8C;EAC9C,4BAA4B;AAC9B;AACA;EACE,8CAA8C;AAChD;AACA,eAAe;AACf;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA,mBAAmB;AACnB;EACE,8CAA8C;AAChD;AACA,kBAAkB;AAClB;EACE,iDAAiD;AACnD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,oCAAoC;EACpC,yCAAyC;;EAEzC,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,wCAAwC;AAC1C;AACA;EACE,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,uCAAuC;AACzC;;AAEA;EACE,0DAA0D;EAC1D,uCAAuC;AACzC;;AAEA;EACE,0DAA0D;EAC1D,wDAAwD;AAC1D;;AAEA;EACE,0DAA0D;EAC1D,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;;EAEE,wDAAwD;EACxD,0DAA0D;AAC5D;;AAEA;EACE,+CAA+C;EAC/C,wBAAwB;AAC1B;AACA;EACE,0DAA0D;AAC5D;;AAEA;;;;EAIE,0DAA0D;EAC1D,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,0DAA0D;GACzD,uCAAuC;AAC1C;AACA;EACE,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,8EAA8E;EAC9E,yDAAyD;AAC3D;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE;;;;;;;IAOE;EACF,yFAAyF;EACzF;;;;GAIC;;EAED,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,8CAA8C;AAChD;AACA,iBAAiB;AACjB;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB,EAAE,eAAe;EACvC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB,EAAE,gBAAgB;EACxC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC","sourcesContent":["\r\n:root {\r\n  --themeColor: #fafaff;\r\n  --themeFontColor: #000000;\r\n  --themeColorLighterShade: #e6e6ef;\r\n  --themeColorLightestShade: #f0f0f4;\r\n  --themeShadowColor: rgba(50, 50, 93, 0.25);\r\n  --themeShadowLighterColor: rgba(0, 0, 0, 0.3);\r\n  --themeShadow: var(--themeShadowColor) 0px 6px 12px -2px,\r\n    var(--themeShadowLighterColor) 0px 3px 7px -3px;\r\n  --tableHeadFontColor: #fff;\r\n  --formBorderLineColor: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* ::-webkit-scrollbar {\r\n  width: 0px !important;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f100 !important; \r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #88888800 !important; \r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #55555500 !important; \r\n} */\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\r\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* * {\r\n  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important;\r\n\r\n} */\r\n* {\r\n  font-family: \"JesayaBk-Regular\" !important;\r\n  letter-spacing: 0.5px !important;\r\n}\r\ninput[value=\"\"]::-webkit-datetime-edit {\r\n  /* color: transparent; \r\n  -webkit-text-fill-color: #5b5b9800; */\r\n}\r\n\r\n/* input,.Mui-disabled{\r\n  color:black !important;\r\n  -webkit-text-fill-color: #000 !important;\r\n} */\r\ninput {\r\n  color: var(--themeFontColor) !important;\r\n  -webkit-text-fill-color: var(--themeFontColor) !important;\r\n  color-scheme: var(--themeFontColor) !important;\r\n}\r\n.Mui-disabled {\r\n  /* color:var(--themeFontColor) !important; */\r\n  /* -webkit-text-fill-color: var(--themeFontColor) !important; */\r\n}\r\ntd img {\r\n  max-height: 4rem;\r\n  max-width: 4rem;\r\n  border-radius: 10px;\r\n  /* box-shadow: var(--themeShadow); */\r\n}\r\na {\r\n  text-decoration: none !important;\r\n}\r\n/* a:focus{\r\n  color: var(--themeFontColor) !important;\r\n  \r\n} */\r\n/* thead th:first-child {\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n}\r\nthead th:last-child {\r\n  border-top-right-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n} */\r\n/* .MuiOutlinedInput-notchedOutline{\r\n  outline: #000 !important;\r\n  border-color: #000 !important;\r\n} */\r\n.MuiOutlinedInput-notchedOutline {\r\n  outline: var(--themeFontColor) !important;\r\n  border-color: var(--themeFontColor) !important;\r\n}\r\n.MuiChip-label,\r\n.MuiCheckbox-root,\r\n.MuiSelect-select,\r\n.css-16901u4-MuiFormLabel-root,\r\n.css-17xv29d-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root,\r\n.MuiOutlinedInput-notchedOutline {\r\n  border-radius: 10px !important;\r\n  /* border-color: black !important; */\r\n  /* color:black !important; */\r\n  color: var(--themeFontColor) !important;\r\n}\r\n.MuiInputLabel-root,\r\n.MuiInputLabel-formControl {\r\n  color: var(--themeFontColor) !important;\r\n}\r\n.css-12rm877-MuiPaper-root-MuiAutocomplete-paper {\r\n  color: red !important;\r\n}\r\n\r\n.rs-picker-default .rs-picker-toggle.rs-btn-lg {\r\n  height: auto !important;\r\n  width: 100% !important;\r\n  padding: 16.5px 14px !important;\r\n  padding-left: 48px !important;\r\n  font-size: 0.8571428571428571rem !important;\r\n  background: rgb(0, 0, 0, 0) !important;\r\n  border: black 1px solid !important;\r\n  border-radius: 8px !important;\r\n}\r\n.rs-btn-md {\r\n  height: auto !important;\r\n  width: 100% !important;\r\n  padding: 10px 14px !important;\r\n  /* padding-left: 48px !important; */\r\n  font-size: 0.8571428571428571rem !important;\r\n  background: var(--themeColor) !important;\r\n  border: var(--themeColor) 1px solid !important;\r\n  border-radius: 8px !important;\r\n}\r\n/* .rs-picker-default .rs-btn .rs-picker-default .rs-picker-toggle {\r\n  background-color: black !important;\r\n\r\n} */\r\n.rs-picker-default .rs-btn,\r\n.rs-picker-input .rs-btn,\r\n.rs-picker-default .rs-picker-toggle,\r\n.rs-picker-input .rs-picker-toggle {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.rs-picker-toggle-caret {\r\n  top: 30% !important;\r\n}\r\n.rs-picker-toggle-value,\r\n.rs-picker-toggle-textbox {\r\n  color: var(--themeFontColor) !important;\r\n    background-color: var(--themeColor) !important;\r\n}\r\n.MuiFormLabel-asterisk,\r\n.MuiInputLabel-asterisk,\r\n.MuiFormHelperText-root {\r\n  color: red !important;\r\n}\r\n\r\n.Mui-selected {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n/* tr td:first-child {\r\n  border-top-left-radius: 1rem;\r\n  border-bottom-left-radius: 1rem;\r\n}\r\ntr td:last-child {\r\n  border-top-right-radius: 1rem;\r\n  border-bottom-right-radius: 1rem;\r\n} */\r\n.MuiAutocomplete-option {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.MuiAutocomplete-option:hover {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.MuiAlert-root {\r\n  background-color: transparent !important;\r\n  background: linear-gradient(\r\n    225deg,\r\n    var(--gradientColor1) 0%,\r\n    var(--gradientColor2) 91.25%\r\n  ) !important;\r\n  color: var(--tableHeadFontColor) !important;\r\n}\r\n.invalid-number-message {\r\n  background: var(--themeFontColor) !important;\r\n}\r\n/* .css-4o1hlg-MuiGrid-root{\r\ndisplay: inline !important;\r\n} */\r\n\r\n.css-4o1hlg-MuiGrid-root {\r\n  flex-wrap: nowrap !important;\r\n}\r\n/* dark  mode */\r\n.css-eyrg6t-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator {\r\n  color: var(--themeFontColor) !important;\r\n}\r\n.apexcharts-legend-text {\r\n  color: #e55e08 !important;\r\n}\r\n.css-1rqvyhg-MuiButtonBase-root-MuiMenuItem-root {\r\n  color: #e55e08 !important;\r\n}\r\n/* top bar */\r\n.css-1m7rcoi-MuiPaper-root-MuiAppBar-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-vcjevh-MuiButtonBase-root-MuiIconButton-root {\r\n  color: var(--themeFontColor) !important;\r\n}\r\n.CurrentDate_currentDate__wTUkF {\r\n  border: 1px solid var(--themeFontColor) !important;\r\n  color: var(--themeFontColor) !important;\r\n}\r\n.Notifications_Notifications__s5SGE {\r\n  border: 1px solid var(--themeFontColor) !important;\r\n  color: green !important;\r\n}\r\n/* chart */\r\n.apexcharts-toolbar {\r\n  background-color: var(--themeFontColor);\r\n}\r\n.css-gaunrm-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n  /* border: 1px solid #363535 ; */\r\n  box-shadow: var(--themeShadow) !important;\r\n}\r\n.css-uhtw1w-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n  box-shadow: var(--themeShadow) !important;\r\n\r\n  /* border: 1px solid #363535 ; */\r\n}\r\n.css-1ie4o9w-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n  box-shadow: var(--themeShadow) !important;\r\n\r\n  /* border: 1px solid #363535 ; */\r\n}\r\n.css-1eg9ojj-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n  /* border: 1px solid #363535 ; */\r\n  box-shadow: var(--themeShadow) !important;\r\n}\r\n/* table */\r\n.css-upajmk-MuiTablePagination-selectLabel {\r\n  color: var(--themeFontColor);\r\n}\r\n.css-11ceysh-MuiTablePagination-displayedRows {\r\n  color: var(--themeFontColor);\r\n}\r\n.css-1knvo2r-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-mja77w-MuiTableRow-root.MuiTableRow-hover:hover {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-1hrspu2-MuiPaper-root-MuiTableContainer-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-geaot0-MuiButtonBase-root-MuiMenuItem-root-MuiTablePagination-menuItem {\r\n  color: red !important;\r\n}\r\n/* video details */\r\n.css-zqdn1f-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-1bzmum7-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n  border: 1px solid #363535;\r\n}\r\n.css-kke3go-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n/* form */\r\n.css-g5736s-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-7imk2x-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-1bqcgw2-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-q8j02b {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-drd2zr-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {\r\n  color: var(--themeFontColor) !important;\r\n}\r\n.css-1a2gpc6-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.form_phoneInput__pFBPS {\r\n  border: 1px solid red !important;\r\n}\r\n.form_phoneInput__LEbig {\r\n  border: 1px solid var(--themeFontColor) !important;\r\n}\r\n/* customer details */\r\n.css-ytlvh1-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n  /* border: 1px solid #363535 ; */\r\n  box-shadow: var(--themeShadow) !important;\r\n}\r\n.css-130ds3b-MuiPaper-root-MuiCard-root {\r\n  background: linear-gradient(\r\n    225deg,\r\n    var(--themeColor) 0%,\r\n    #232121 91.25%\r\n  ) !important;\r\n  /* border: 1px solid #363535 ; */\r\n  box-shadow: var(--themeShadow) !important;\r\n}\r\n.css-1nzdg76-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n  /* border: 1px solid #363535 ; */\r\n  box-shadow: var(--themeShadow) !important;\r\n}\r\n.css-8oekft-MuiTableHead-root {\r\n  background-color: var(--themeColor) !important;\r\n  /* border: 1px solid #363535 ; */\r\n  box-shadow: var(--themeShadow) !important;\r\n}\r\n.css-emol3q-MuiTableCell-root {\r\n  border-bottom: 1px solid rgb(97 97 97) !important;\r\n}\r\n.css-1vckdgf-MuiTableCell-root {\r\n  border-bottom: 1px solid rgb(97 97 97) !important;\r\n}\r\n.css-14a324z-MuiTableCell-root {\r\n  border-bottom: 1px solid rgb(97 97 97) !important;\r\n}\r\n.css-ryg23w-MuiTableCell-root {\r\n  border-bottom: 1px solid rgb(97 97 97) !important;\r\n}\r\n.css-fdk6dw {\r\n  border-bottom: 1px solid rgb(97 97 97) !important;\r\n}\r\n/* description */\r\n.mantine-1qycoz3 .ql-editor {\r\n  background-color: var(--themeColor) !important;\r\n  color: var(--themeFontColor);\r\n}\r\n.mantine-bdajhj {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n/* login page */\r\n.css-1rlv2y8 {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n.css-1rlv2y8 {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n/* series Details */\r\n.css-j5uqg9-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n/* movie details */\r\n.css-q327nh-MuiTableCell-root {\r\n  border-bottom: 1px solid rgb(97 97 97) !important;\r\n}\r\n.css-1kxu69z {\r\n  color: var(--themeFontColor) !important;\r\n}\r\n.css-1trvfeo-MuiPaper-root-MuiCard-root {\r\n  background-color: #363535 !important;\r\n  box-shadow: var(--themeShadow) !important;\r\n\r\n  border: 1px solid #363535;\r\n}\r\n\r\n/* popup */\r\n.css-13oa6c8 {\r\n  background: var(--themeColor) !important;\r\n}\r\n.css-228tnr-MuiPaper-root-MuiCard-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n\r\n/* log in form */\r\n.css-poa6bm-MuiButtonBase-root-MuiIconButton-root {\r\n  color: var(--themeFontColor) !important;\r\n}\r\n\r\n.rs-picker-menu {\r\n  background-color: var(--themeColorLighterShade) !important;\r\n  color: var(--themeFontColor) !important;\r\n}\r\n\r\n.rs-picker-toggle-textbox {\r\n  background-color: var(--themeColorLighterShade) !important;\r\n  /* border: 1px solid var(--themeFontColor) !important; */\r\n}\r\n\r\n.rs-picker-toggle-textbox:visited {\r\n  background-color: var(--themeColorLighterShade) !important;\r\n  /* border: 1px solid var(--themeFontColor) !important; */\r\n}\r\n\r\n.rs-picker-toggle-wrapper {\r\n  /* border: 1px solid var(--themeFontColor); */\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.rs-picker:not(.rs-picker-disabled):hover,\r\n.rs-picker.rs-picker-focused {\r\n  /* border: 1px solid var(--themeFontColor) !important; */\r\n  background-color: var(--themeColorLighterShade) !important;\r\n}\r\n\r\n.rs-calendar-table-cell:hover {\r\n  background-color: var(--themeColorLighterShade);\r\n  color: var(--themeColor);\r\n}\r\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-selected-start {\r\n  background-color: var(--themeColorLighterShade) !important;\r\n}\r\n\r\n.rs-picker-menu\r\n  .rs-calendar\r\n  .rs-calendar-table-cell:hover\r\n  .rs-calendar-table-cell-content {\r\n  background-color: var(--themeColorLighterShade) !important;\r\n  color: var(--themeFontColor);\r\n}\r\n.calendar-bg .rs-picker-toggle-wrapper {\r\n  width: 100% !important;\r\n}\r\n\r\n.calendar-bg .rs-picker-date .rs-picker-toggle.rs-btn-md,\r\n.rs-picker-daterange .rs-picker-toggle.rs-btn-md {\r\n  background-color: var(--themeColorLighterShade) !important;\r\n   color: var(--themeFontColor) !important;\r\n}\r\n.custom-date-picker {\r\n  border-radius: 2px !important;\r\n  background-color: var(--themeColorLighterShade) !important;\r\n}\r\n\r\n.custom-date-picker input:-webkit-autofill {\r\n  -webkit-box-shadow: 0 0 0 100px var(--themeColorLighterShade) inset !important;\r\n  -webkit-text-fill-color: var(--themeFontColor) !important;\r\n}\r\n\r\n.dark-mode .custom-date-picker input:-webkit-autofill {\r\n  -webkit-box-shadow: 0 0 0 100px rgb(22, 22, 22) inset !important;\r\n}\r\n\r\n.light-mode .custom-date-picker input:-webkit-autofill {\r\n  -webkit-box-shadow: 0 0 0 100px rgb(255, 255, 255) inset !important;\r\n}\r\n\r\n.features_box:hover {\r\n  /* box-shadow: 0em 0.5em .5em -0.4em rgba(226, 93, 102, 0.8),\r\n  \r\n  0.5em 0em .5em -0.4em rgba(226, 93, 102, 0.8),\r\n  0em -0.5em .5em -0.4em rgba(157, 88, 163, 0.8),\r\n  \r\n  -0.5em 0em .5em -0.4em rgba(157, 88, 163, 0.8)\r\n\r\n ; */\r\n  /* background:linear-gradient(270deg,rgba(157, 88, 163, 0.8),rgba(226, 93, 102, 0.8)) ; */\r\n  background: linear-gradient(\r\n    270deg,\r\n    var(--gradientColor1),\r\n    var(--gradientColor2)\r\n  );\r\n\r\n  box-shadow: none !important;\r\n}\r\n.features_box:hover span {\r\n  color: white !important;\r\n}\r\n.jvectormap-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.jvectormap-tip {\r\n  position: absolute !important;\r\n}\r\n.jvectormap-tip:empty {\r\n  display: none;\r\n}\r\n.map {\r\n  height: 50vh;\r\n}\r\n#root .css-1klsplc-MuiStepLabel-label.Mui-error {\r\n  color: #d32f2f !important;\r\n}\r\n#root .css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-error {\r\n  color: #d32f2f !important;\r\n}\r\n.css-8t4c91 {\r\n  width: 100% !important;\r\n}\r\n\r\n.css-1kxloj4-MuiButtonBase-root-MuiButton-root-MuiLoadingButton-root.Mui-disabled {\r\n  color: #fff !important;\r\n}\r\n.css-1hfcet8-MuiTableRow-root {\r\n  background-color: var(--themeColor) !important;\r\n}\r\n/* Base styling */\r\n.scrollable-content::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n.scrollable-content::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n/* Dark mode scrollbar */\r\n.dark-scrollbar::-webkit-scrollbar-thumb {\r\n  background-color: #555; /* dark thumb */\r\n  border-radius: 4px;\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n.dark-scrollbar::-webkit-scrollbar-thumb:hover {\r\n  background-color: #777;\r\n}\r\n\r\n/* Light mode scrollbar */\r\n.light-scrollbar::-webkit-scrollbar-thumb {\r\n  background-color: #bbb; /* light thumb */\r\n  border-radius: 4px;\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n.light-scrollbar::-webkit-scrollbar-thumb:hover {\r\n  background-color: #999;\r\n}\r\n\r\n/* Optional: Firefox support */\r\n.scrollable-content {\r\n  scrollbar-width: thin;\r\n}\r\n.dark-scrollbar {\r\n  scrollbar-color: #555 transparent;\r\n}\r\n.light-scrollbar {\r\n  scrollbar-color: #bbb transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
